import { FLAT_RATE_PLANS, flatRatePlanNames } from "@common/flatRateBilling";
import { WorkspaceDetails } from "@common/types/workspace";
import { usePlanManagement } from "@components/billing/PlanManagement/PlanManagementContext";
import { useActiveWorkspaceDetails } from "@hooks/useActiveWorkspaceDetails";
import { FC, useCallback, useEffect, useRef } from "react";

interface Props {
    onContinue: () => void;
}

export const Subscribe: FC<Props> = ({ onContinue }) => {
    const activeWorkspaceDetails =
        useActiveWorkspaceDetails() as WorkspaceDetails;
    const { upgrade } = usePlanManagement();
    const modalShownRef = useRef(false);

    const handleClosedWithoutSubscription = useCallback(() => {
        onContinue();
    }, [onContinue]);

    useEffect(() => {
        if (modalShownRef.current) {
            return;
        }
        modalShownRef.current = true;
        const organization =
            activeWorkspaceDetails.organizationAssignments[0]?.organization;

        const planToSubscribeTo = activeWorkspaceDetails.workspace
            .planBeforeTransfer as FLAT_RATE_PLANS;

        upgrade(planToSubscribeTo, false, {
            onHide: handleClosedWithoutSubscription,
            title: organization ? (
                <>
                    {organization.name} suggests{" "}
                    {flatRatePlanNames[planToSubscribeTo]} Plan
                </>
            ) : null,
        });
    }, [upgrade, activeWorkspaceDetails, handleClosedWithoutSubscription]);

    return null;
};
